import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const PageHero = ({ badge, title, subtitle, description, children }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={fadeUp}
      className="relative overflow-hidden rounded-3xl mb-16"
    >
      <div className="relative bg-gradient-to-r from-yellow-900/30 via-yellow-800/10 to-yellow-900/30 border border-white/10 rounded-3xl p-8 md:p-12 overflow-hidden">
        {/* Decorative blobs */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-600/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-yellow-600/20 rounded-full blur-2xl translate-y-1/2 -translate-x-1/2" />

        <div className="relative z-10">
          {badge && (
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-500/20 border border-yellow-500/30 text-yellow-300 text-sm font-medium tracking-wider uppercase mb-4">
              {/* <Sparkles size={14} />  */}
              {badge}
            </span>
          )}
          <h1
            className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {subtitle && (
            <p className="text-gray-300 text-base md:text-lg mt-2 max-w-2xl">
              {subtitle}
            </p>
          )}
          {description && (
            <p className="text-gray-400 text-sm md:text-base mt-2 max-w-2xl">
              {description}
            </p>
          )}
          {children && <div className="mt-4">{children}</div>}
        </div>
      </div>
    </motion.div>
  );
};

export default PageHero;